"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNodeNamesByGroup = void 0;
const getNodeNamesByGroup = (schema, group) => {
    return Object.values(schema.nodes)
        .filter((node) => node.spec.group?.includes(group))
        .map((node) => node.name);
};
exports.getNodeNamesByGroup = getNodeNamesByGroup;
